var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"absolute","width":"100%","height":"100%","top":"0px","left":"0px"}},[_c('compute-frame',{attrs:{"imageInfo":_vm.imageInfo,"path":_vm.path,"noReuse":_vm.forceNew}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4565cad2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/compute/ComputeApp.vue
// module id = APis
// module chunks = 1